import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/liikunta';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-298" data-mp="pujbbk8fgd8b">
      <div className="mx-auto max-w-6xl" data-id="element-299" data-mp="b5wneu4qid5h">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-300" data-mp="b4vd4rvjluot">
          Mitä <em className="text-red-700" style={{
          hyphens: 'manual'
        }} data-id="element-301" data-mp="2603t6x7c4ha">LIIKUNTA VALMIS™</em> sisältää?
        </h2>
        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-302" data-mp="74bfln724p25">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-303" data-mp="72guo8vscwy2">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-304" data-mp="3tazxyudgzhda">{volumesIntro.text}</p>
        </div>
        <div role="tablist" aria-label="Osat" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-305" data-mp="3cscqf91biy5o">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-306" data-mp="3lshxtj6ihwju" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-307" data-mp="2af74qxc7c3p0">{item.number}</span>
                <span className="mt-1 font-serif text-3xl leading-none" data-id="element-308" data-mp="26dtved9whidc">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-309" data-mp="26c0yhpp3acij">
                  {item.title}
                </span>
              </button>;
        })}
        </div>
        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-310" data-mp="j30vynxjyxle">
          <AnimatePresence mode="wait" initial={false} data-id="element-311" data-mp="o12d33bf4mu8">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-312" data-mp="3mjr6ng42xytf">
              <div className="lg:col-span-5" data-id="element-313" data-mp="5cxfkdlcty3v">
                <p className="text-sm font-semibold text-red-700" data-id="element-314" data-mp="1bs7tpkp6nj5l">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-315" data-mp="1gp7zrvm18lwp">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-316" data-mp="3180qhgzn4clm">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-317" data-mp="2wailg1oquhiw">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-318" data-mp="2rgxkq1vrn9g0">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-319" data-mp="2mkpddant8kje">Sisältö</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-320" data-mp="2hkkwvkmwjpt6">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-321" data-mp="2djhht0cohxt0">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-322" data-mp="28jmpqth6326d" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-323" data-mp="6tb95al87d9z">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-324" data-mp="1uq4myyxy7fq">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-325" data-mp="2znrum1eij60v">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-326" data-mp="2zkxcwhmvvzb5">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-327" data-mp="2lmyyjc8kc2vn">
              Mikä tekee LIIKUNTA VALMIS™ -paketista erilaisen?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-328" data-mp="2bwvy4qz43mna">
              Koko lukuvuoden liikunta – järjestettynä ja käyttövalmiina.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-329" data-mp="22y26lf0n1mgl">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-330" data-mp="1sz364jq10x4o">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-331" data-mp="1t04hyqev9nng" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-332" data-mp="1xwuzzja8etbi">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-333" data-mp="1ecw3ngq9h279">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}